/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    component: () =>
      import(

        /* webpackChunkName: "orders" */
        '@/modules/products-offered/scenes/products-offered-list/products-offered-list.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.PRODUCTS.PRODUCTS_OFFERED,
    path: 'products-offered/list'
  }
] as RouteConfig[];
